export const CREATE_SMS = 'CREATE_SMS';
export const FETCH_SMS_STATUSES = 'FETCH_SMS_STATUSES';
export const FETCH_SCHEDULED_SMS = 'FETCH_SCHEDULED_SMS';
export const FETCH_CANCELLED_SMS = 'FETCH_CANCELLED_SMS';
export const CANCEL_SCHEDULED_SMS = 'CANCEL_SCHEDULED_SMS';
export const FETCH_SMS_CLICKS = 'FETCH_SMS_CLICKS';
export const FETCH_CHAT_LIST = 'FETCH_CHAT_LIST';
export const FETCH_MESSAGES_BY_CHAT_ID = 'FETCH_MESSAGES_BY_CHAT_ID';
export const REPLY_TO_THE_CHAT = 'REPLY_TO_THE_CHAT';
export const CREATE_CHAT_SETTING = 'CREATE_CHAT_SETTING';
export const GET_CHAT_SETTING = 'GET_CHAT_SETTING';
export const UPDATE_CHAT_SETTING = 'UPDATE_CHAT_SETTING';

